import BaseStore from "../base/BaseStore";
import {
  ActionInterface,
  AuthenticationActionsType,
} from "../constant/ActionConstant";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Establishment from "../model/Establishment";


class AuthenticationStore extends BaseStore {
  private _selectedEstablishment: Establishment | undefined;
  private _establishments: Establishment[];

  constructor() {
    super();
    this._selectedEstablishment = undefined;
        this._establishments = [];
    }

  public get establishments(): Establishment[] {
    return this._establishments;
  }

  public get selectedEstablishment(): Establishment | undefined {
    return this._selectedEstablishment;
  }

  addEstablishment(establishment: Establishment) {
    if (
      this._establishments.find((e) => e.id === establishment.id) === undefined
    ) {
      this._establishments.push(establishment);
      this.emitChange();
    }
  }

  setEstablishments(establishments: Establishment[]) {
    this._establishments = establishments;
    this.emitChange();
  }

  setSelectedEstablishment(establishment: Establishment) {
    this._selectedEstablishment = establishment;
    this.emitChange();
  }

  disconnect() {
    this._selectedEstablishment = undefined;
    this._establishments = [];
    this.emitChange();
  }
}

const storeActions = (store: AuthenticationStore) => {
  return (action: ActionInterface) => {
    switch (action.type) {
      case AuthenticationActionsType.LOGGED:
        store.setEstablishments(action.data);
        break;

      case AuthenticationActionsType.SELECT_ESTABLISHMENT:
        store.setSelectedEstablishment(action.data);
        break;

      case AuthenticationActionsType.LOGGED_FIR:
        return;

      default:
        return;
    }
  };
};

const sharedStore = new AuthenticationStore();
sharedStore.dispatchToken = AppDispatcher.register(
  storeActions(sharedStore) as (payload: unknown) => void
);

export default sharedStore;
export const Store = AuthenticationStore;
export const actions = storeActions;
